import { render, staticRenderFns } from "./-VideoCard.vue?vue&type=template&id=96006136&scoped=true&"
import script from "./-VideoCard.vue?vue&type=script&lang=js&"
export * from "./-VideoCard.vue?vue&type=script&lang=js&"
import style0 from "./-VideoCard.vue?vue&type=style&index=0&id=96006136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96006136",
  null
  
)

export default component.exports